import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

// pwap promot
import PWAPrompt from 'react-ios-pwa-prompt';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

import Appointments from './Appointments/Appointments';
import ScheduleSetting from './Setting/ScheduleSetting';

import * as actions from '../../store/actions/index';

import classes from './Profile.css';

import PersonalInformation from './PersonalInformation/PersonalInformation';
import Relation from './Relation/Relation';

import { useMobile } from '../../store/utility';

class Profile extends React.Component{

    componentDidMount() {
        if (this.props.isAuthenticated === true) {
            this.props.getSetting();
            this.props.getAppointments();
            this.props.getRelations();
        }
        else {
            setTimeout(
                () => {
                    this.props.getSetting();
                    this.props.getAppointments();
                },
                100
            )
        }
        window.scrollTo(0, 0);
    }

    handleSaveSetting = (weekScheduleSetting) => {
        this.props.saveScheduleSetting(this.props.calendar_id, weekScheduleSetting);
    }

    scheduleHasBeenSet = () => {
        let scheduleHasBeenSet = false;
        let day;
        for (day in this.props.weekSchedule.days) {
            if (this.props.weekSchedule.days[day] != null) {
                scheduleHasBeenSet = true;
                break;
            }
        }
        return scheduleHasBeenSet
    }

    render() {

        // redirect to auth if it is not logged in
        if (this.props.isAuthenticated===false) {
            return (<Redirect to={this.props.authPath}/>);
        }

        let isMobile = useMobile();
        let topContent = '';
        let bottomConetent = '';
        if (this.props.hasSchedule === false) {
            topContent = (
                <Row>
                    <Col>
                        <div className={classes.ProfileBody}>
                            <ScheduleSetting isMobile={isMobile}></ScheduleSetting>
                        </div>
                    </Col>
                </Row>
            )
        }
        else {
            bottomConetent = (
                <Row>
                    <Col>
                        <div className={classes.ProfileBody}>
                            <ScheduleSetting isMobile={isMobile}></ScheduleSetting>
                        </div>
                    </Col>
                </Row>
            )
        }


        return (
            <div className={classes.Profile}>
            <Helmet>
                <title>Profile | BookMeeY</title>
                <meta name="description" content="Your BookMeeY page. Here is where you can check your profile, share your calendar booking link, set your schedule, and manage your appointments." />
            </Helmet>
            <Container>
                { topContent }
                <Row>
                    <Col>
                    <div className={classes.ProfileBody}>
                        <PersonalInformation isMobile={isMobile}></PersonalInformation>
                    </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <div className={classes.ProfileBody}>
                        <Appointments isMobile={isMobile}></Appointments>
                    </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <div className={classes.ProfileBody}>
                        <Relation isMobile={isMobile}></Relation>
                    </div>
                    </Col>
                </Row>
                { bottomConetent }
            </Container>
            <PWAPrompt promptOnVisit={1} timesToShow={10} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        weekSchedule: state.setting.weekSchedule,
        appointments: state.appointment.appointments,
        isAuthenticated: state.auth.token !== null,
        authPath: state.auth.authPath,
        hasSchedule: state.auth.hasSchedule
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSetting: (calendar_id) => dispatch( actions.settingGet(calendar_id) ),
        getAppointments: () => dispatch( actions.appointmentGet() ),
        getRelations: () => dispatch( actions.relationGet() ),
        saveScheduleSetting: (calendar_id, scheduleSetting) => dispatch( actions.scheduleSettingSet(calendar_id, scheduleSetting) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (Profile);


// WEBPACK FOOTER //
// ./src/containers/Profile/Profile.js